import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import MyPage from "../../../src/MyPage";
import SubTabsGeneralParams from "../../../src/SubTabsGeneralParams";
import { isSuperAdmin } from "./../../helpers/user.js";
import axiosService from '../../helpers/axios';

  
    export default class GeneralParamsContainers extends Component{ 
  
      constructor(props){
        super(props);
  
        this.state={
            containers:[],
            modalTitle:"",
            containername:"",
            containerid:0,
            containerdescription:"",
            containertype: {
              containertypename: ""
            },
            podelay:"",
            timetowarehouse:"",
            isactive:true,
            OriginCountry: {
              countryname: "",
              countryid:0,
          },
  
            ContainerIdFilter:"",
            ContainerNameFilter:"",
            ContainerDescriptionFilter:"",
            IsactiveFilter:"",
            CountryNameFilter:"",
            containersWithoutFilter:[],
            countryNames: [],
            containerTypeNames: [] ,
            containerDescriptions: [],
            containerDescriptionExists: false,
            uniqueContainerIdsPurchases:[],
            uniqueProductIdsContainersContent:[],  
        }
    }
  
    FilterFn(){
      var ContainerIdFilter=this.state.ContainerIdFilter;
      var ContainerNameFilter = this.state.ContainerNameFilter;
      var ContainerDescriptionFilter = this.state.ContainerDescriptionFilter;
      var IsactiveFilter = this.state.IsactiveFilter;
      var CountryNameFilter = this.state.CountryNameFilter
  
      var filteredData=this.state.containersWithoutFilter.filter(
          function(el){
              return el.containerid.toString().toLowerCase().includes(
                  ContainerIdFilter.toString().trim().toLowerCase()
              )&&
              el.containername.toString().toLowerCase().includes(
                  ContainerNameFilter.toString().trim().toLowerCase()
              )&&
              el.containerdescription.toString().toLowerCase().includes(
                  ContainerDescriptionFilter.toString().trim().toLowerCase()
              )&&
              el.isactive.toString().toLowerCase().includes(
                  IsactiveFilter.toString().trim().toLowerCase()
              )&&
              el.OriginCountry.countryname.toString().toLowerCase().includes(
                  CountryNameFilter.toString().trim().toLowerCase()
              )
          }
      );
  
      this.setState({containers:filteredData});
  
  }
  
  sortResult(prop,asc){
    var sortedData=this.state.containersWithoutFilter.sort(function(a,b){
        if(asc){
            return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
        }
        else{
            return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
        }
    });
  
    this.setState({containers:sortedData});
  
  }
  
  changeContainerIdFilter = (e)=>{
    this.state.ContainerIdFilter=e.target.value;
    this.FilterFn();
  }
  changeContainerNameFilter = (e)=>{
    this.state.ContainerNameFilter=e.target.value;
    this.FilterFn();
  }


  changeContainerDescriptionFilter = (e)=>{
    this.state.ContainerDescriptionFilter=e.target.value;
    this.FilterFn();
  }

  
changeIsActiveFilter = (e)=>{
  this.state.IsactiveFilter=e.target.value;
  this.FilterFn();
}

changeCountryNameFilter = (e)=>{
  this.state.CountryNameFilter=e.target.value;
  this.FilterFn();
}
  
  refreshList(){
    axiosService.get('/containers/')
    .then(response=>{
        const data = response.data?.results ?? response.data;
        this.setState({containers:data,containersWithoutFilter:data});
    });
  }
  

  
fetchCountryNames() {
  axiosService.get('/countrynames/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const filteredData = data.filter(item => item.isactive === true);
      const countryNames = filteredData.map(item => item.countryname);
      this.setState({ countryNames: countryNames });
    })
    .catch(error => {
      console.error("Error fetching country names:", error);
    });
}

fetchContainerTypeNames() {
  axiosService.get('/containertypes/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const containerTypeNames = data.map(item => item.containertypename);
      this.setState({ containerTypeNames: containerTypeNames });
    })
    .catch(error => {
      console.error("Error fetching country names:", error);
    });
}

fetchContainerDescriptions() {
  axiosService.get('/containers/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const containerDescriptions = data.map(item => item.containerdescription);
      this.setState({ containerDescriptions: containerDescriptions });
    })
    .catch(error => {
      console.error("Error fetching container descriptions:", error);
    });
}

checkContainerDescriptionExists = (event) => {
  const enteredContainerDescription = event.target.value.toLowerCase(); // Convert to lowercase
  const { containerDescriptions } = this.state;
  const containerDescriptionExists = containerDescriptions.some((container) => container.toLowerCase() === enteredContainerDescription);
  this.setState({ containerDescriptionExists });
};

handleInput = (event) => {
  const inputValue = event.target.value;
  const regex = /^\d*$/;
  if (!regex.test(inputValue)) {
    event.target.value = inputValue.replace(/[^0-9]/g, '');
  }
};

fetchContainerIdsPurchases() {
  axiosService.get('/purchasescreate/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      // Filter the data where purchasetypeid is equal to 1
      const filteredData = data.filter((item) => item.purchasetypeid === 1);

      // Extract unique warehouseid values from the filtered data
      const uniqueContainerIdsPurchases = [...new Set(filteredData.map((item) => item.itempurchasedid_id))];

      this.setState({ uniqueContainerIdsPurchases: uniqueContainerIdsPurchases });
    })
    .catch((error) => {
      console.error('Error fetching Containers data:', error);
    });
}

fetchContainerIdsContainersContent() {
  axiosService.get('/containerscontent/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      const uniqueContainerIdsContainersContent = [...new Set(data.map((item) => item.containerid))];
      this.setState({ uniqueContainerIdsContainersContent: uniqueContainerIdsContainersContent });
    })
    .catch((error) => {
      console.error('Error fetching Containers Content data:', error);
    });
}



  componentDidMount(){
    this.refreshList();
    this.fetchCountryNames();
    this.fetchContainerTypeNames();
    this.fetchContainerDescriptions();
    this.fetchContainerIdsPurchases();
    this.fetchContainerIdsContainersContent();
    
  }
  
  changeContainerName =(e)=>{
    this.setState({containername:e.target.value});
  }

  changeContainerDescription =(e)=>{
    this.setState({containerdescription:e.target.value});
  }
  
  changeContainerTypeName =(e)=>{
    this.setState({containertypename:e.target.value});
  }

  changePoDelay =(e)=>{
    this.setState({podelay:e.target.value});
  }

  changeTimeToWarehouse =(e)=>{
    this.setState({timetowarehouse:e.target.value});
  }

  changeIsActive = (event) => {
    const isChecked = event.target.checked;
    this.setState({ isactive: isChecked });
  };
  
  changeCountryName =(e)=>{
    this.setState({countryname:e.target.value});
  } 



  addClick(){
    this.setState({
        modalTitle:"Add Container",
        containerid:0,
        containername: "",
        containerdescription: "",
        containertypename:"",
        podelay:"",
        timetowarehouse:"",
        isactive: true,
        countryname:"",
        containerDescriptionExists: false,
    });
  }
  editClick(dep){
    this.setState({
        modalTitle:"Edit Container",
        containerid:dep.containerid,
        containername:dep.containername,
        containerdescription:dep.containerdescription,
        containertypename:dep.containertype.containertypename,
        podelay:dep.podelay,
        timetowarehouse:dep.timetowarehouse,
        isactive:dep.isactive,
        countryname:dep.OriginCountry.countryname,
        initialContainerdescription:dep.containerdescription,
        initialContainertypename:dep.containertype.containertypename,
        initialPodelay:dep.podelay,
        initialTimetowarehouse:dep.timetowarehouse,
        initialIsactive:dep.isactive,
        initialCountryname:dep.OriginCountry.countryname,
        containerDescriptionExists: false,
    });
  }
  
  createClick() {
    const { containername, containerdescription,containertypename,podelay, timetowarehouse, isactive,countryname, containerDescriptions } = this.state;

    if (!containerdescription) {
      alert('Container Description is required');
      return;
    }

    if (containerDescriptions.some(name => name.toLowerCase() === containerdescription.toLowerCase())) {
      alert('Container Description already exists. Please provide a unique Container Description.');
      return;
    }

    if (!containertypename) {
      alert('Container Type is required');
      return;
    }

    if (!podelay) {
      alert('Po delay is required');
      return;
    }

    if (isNaN(podelay)) {
      alert('Po delay must be a number');
      return;
    }

    

    if (!countryname) {
      alert('Country is required');
      return;
    }
  
    axiosService.post('/containerscreate/', {
        //containername: containername,
        containerdescription: containerdescription,
        containertypename: containertypename,
        podelay:podelay,
        timetowarehouse: timetowarehouse,
        isactive: isactive,
        countryname: countryname
    })
      .then(result => {
        alert('Container created');
        this.refreshList();
        //window.location.reload();
      })
      .catch(error => {
        alert('Failed');
      });
  }
  
  updateClick(id) {
  const { containername, containerdescription, containertypename, podelay, timetowarehouse, isactive, countryname, initialContainerdescription, 
  initialContainertypename, initialPodelay, initialTimetowarehouse, initialIsactive, initialCountryname, containerDescriptions } = this.state;

  // Check if any changes are detected in the form fields
  if (
    containerdescription === initialContainerdescription &&
    containertypename === initialContainertypename &&
    podelay === initialPodelay &&
    timetowarehouse === initialTimetowarehouse &&
    isactive === initialIsactive &&
    countryname === initialCountryname
  ) {
    alert('No changes detected');
    return;
  }

  // Check if the updated containerdescription already exists in containerDescriptions (case-insensitive comparison)
  if (
    containerDescriptions.some((existingContainerDescription) => existingContainerDescription.toLowerCase() === containerdescription.toLowerCase() && containerdescription !== initialContainerdescription
    )
  ) {
    // Reset containerdescription back to its initial value (initialContainerdescription) 
    this.setState({ containerdescription: initialContainerdescription });
    return;
  }

  // If no duplicates and changes detected, proceed with the update via the API
  axiosService.patch('/containers/' + id + '/', {
      // Add other fields as needed...
      containerdescription: this.state.containerdescription,
      containertypename: this.state.containertypename,
      podelay: this.state.podelay,
      timetowarehouse: this.state.timetowarehouse,
      isactive: this.state.isactive,
      countryname: this.state.countryname
  })
  .then((result) => {
    alert('Update successful');
    this.refreshList();
    //window.location.reload(); // Refresh the page
  })
  .catch((error) => {
    alert('Failed');
  });
}

  
  deleteClick(id) {
    if (this.state.uniqueContainerIdsPurchases.includes(id)) {
      alert('Cannot delete this Container as it is in the Purchases Table !');
      return; // Exit the function without making the delete request
    }

    if (this.state.uniqueContainerIdsContainersContent.includes(id)) {
      alert('Cannot delete this Container as it is in the Containers Content Table !');
      return; // Exit the function without making the delete request
    }



    if (window.confirm('Are you sure?')) {
      axiosService.delete('/containers/' + id + '/')
        .then(res => {
          alert('Delete successful');
          this.refreshList();
          //window.location.reload();
        })
        .catch(error => {
          alert(error?.response?.data?.error || error?.message || 'Delete failed');
        });
    }
  }
  
  
  render(){
    const {
        containers,
        modalTitle,
        containerid,
        containername,
        containerdescription,
        containertypename,
        podelay,
        timetowarehouse,
        isactive,
        countryname,
        containerDescriptionExists
    }=this.state;
  
    return(
<div className="scrollable-container">
<MyPage />
<SubTabsGeneralParams />
  <button type="button"
  disabled={!isSuperAdmin()}
  className="btn btn-primary m-2 float-end"
  data-bs-toggle="modal"
  data-bs-target="#exampleModal"
  onClick={()=>this.addClick()}
  style={{  height: "28px", fontSize: "12px" ,textAlign:"center"}}
  >
    Add Container
  </button>
  <div className="table-container-single">
  <table className="table table-striped">
  <thead>
  <tr  className="header-row-fixed">
    <th style={{  fontSize: "12px" ,textAlign:"center"}}>
        <div className="d-flex flex-row align-items-center justify-content-center">
        <input className="form-control m-2"
         style={{ width: "70px", height:"30px",fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
        onChange={this.changeContainerIdFilter}
        placeholder="Filter"/>
  
        </div>
        ContainerId
    </th>
    <th style={{  fontSize: "12px" ,textAlign:"center"}}>
    <div className="d-flex flex-row align-items-center justify-content-center">
    <input className="form-control m-2"
     style={{ width: "200px", height:"30px",fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
        onChange={this.changeContainerNameFilter}
        placeholder="Filter"/>

        </div>
        ContainerName
  
    </th>
    <th style={{  fontSize: "12px" ,textAlign:"center"}}>
    <div className="d-flex flex-row align-items-center justify-content-center">
    <input className="form-control m-2"
     style={{ width: "200px", height:"30px",fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
        onChange={this.changeContainerDescriptionFilter}
        placeholder="Filter"/>
  
        </div>
        ContainerDescription
  
    </th>
    <th style={{  fontSize: "12px" ,textAlign:"center"}}>
    <div className="d-flex flex-row align-items-center justify-content-center">
        </div>
        ContainerTypeName
    </th>
    <th style={{  fontSize: "12px" ,textAlign:"center"}}>
    <div className="d-flex flex-row align-items-center justify-content-center">
        </div>
        PoDelay(months)
    </th>
    <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px",fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeIsActiveFilter}
      placeholder="Filter"/>

      </div>
      Is Active
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
    <div className="d-flex flex-row align-items-center justify-content-center">
    <input className="form-control m-2"
     style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
        onChange={this.changeCountryNameFilter}
        placeholder="Filter"/>

        </div>
        OriginCountry
  
    </th>
    <th style={{  fontSize: "12px" ,textAlign:"center"}}>
        Options
    </th>
  </tr>
  </thead>
  <tbody>
    {containers.map(dep=>
        <tr key={dep.containerid} className="row-hover">
            <td className="table-text">{dep.containerid}</td>
            <td className="table-text">{dep.containername}</td>
            <td className="table-text">{dep.containerdescription}</td>
            <td className="table-text">{dep.containertype.containertypename}</td>
            <td className="table-text">{dep.podelay}</td>
            <td className="table-text">{dep.isactive.toString()}</td>
            <td className="table-text">{dep.OriginCountry.countryname}</td>
            <td className="table-text">
            <button type="button"
            disabled={!isSuperAdmin()}
            className="btn btn-light mr-1  p-0"
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"
            onClick={()=>this.editClick(dep)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                </svg>
            </button>
  
            <button type="button"
            disabled={!isSuperAdmin()}
            className="btn btn-light mr-1  p-0"
            onClick={()=>this.deleteClick(dep.containerid)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash-fill" viewBox="0 0 16 16">
                <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
                </svg>
            </button>
  
            </td>
        </tr>
        )}
  </tbody>
  </table>
  </div>
  
  <div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
    <div className="modal-dialog modal-lg modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title" style={{ fontSize: "12px" }} >{modalTitle}</h5>
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div className="modal-body">
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Container Description</span>
          <input
            type="text"
            className={`form-control ${containerDescriptionExists ? "is-invalid" : ""}`}
            value={containerdescription}
            onChange={this.changeContainerDescription}
            onBlur={this.checkContainerDescriptionExists}
            style={{ fontSize: "12px" }}  
          />
          {containerDescriptionExists && <div className="invalid-feedback" style={{ fontSize: "12px" }} >Container Description already exists.</div>}
        </div>
          <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >ContainerType</span>
          <select
            className="form-select"
            value={this.state.containertypename}
            onChange={(event) => this.setState({ containertypename: event.target.value })}
            required
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select a containerType</option>
            {this.state.containerTypeNames.map((containertype) => (
              <option key={containertype} value={containertype}>
                {containertype}
              </option>
            ))}
          </select>
        </div>
          <div className="input-group mb-3">
            <span className="input-group-text" style={{ fontSize: "12px" }} >PoDelay(months)</span>
            <input  type="number" className="form-control" value={podelay} onChange={this.changePoDelay} 
            onInput={this.handleInput}
            style={{ fontSize: "12px" }} 
            />

          </div>
          <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Isactive</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={isactive}
            onChange={this.changeIsActive}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >OriginCountry</span>
          <select
            className="form-select"
            value={this.state.countryname}
            onChange={(event) => this.setState({ countryname: event.target.value })}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select a country</option>
            {this.state.countryNames.map((country) => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </select>
        </div>
  
          {containerid === 0 ? (
            <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }}  onClick={() => this.createClick()}>
              Create
            </button>
          ) : null}
  
          {containerid !== 0 ? (
            <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }}  onClick={() => this.updateClick(containerid)}>
              Update
            </button>
          ) : null}
        </div>
      </div>
    </div>
  </div>
  
  
  </div>
    )
  }
  
  
    }
  
  